import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FaBuilding,
  FaProjectDiagram,
  FaUsers,
  FaTasks,
  FaSitemap,
  FaUsersCog,
} from "react-icons/fa"; // Importing icons
import "../style/dashboard.css"; // Import CSS for styling
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
const COLORS = [
  "#0088FE",
  "#00C49F",
  "#ff66cc",
  "#FF8042",
  "#845EC2",
  "#FF0000",
];
const Admindashboard = () => {
  const [Data, setDashboardData] = useState([]);
  const [comapnys, setCompanys] = useState(0);
  const [projects, setProjects] = useState(0);
  const [employees, setEmployees] = useState(0);
  const [tasks, setTasks] = useState(0);
  const [teams, setTeams] = useState(0);
  const [departments, setDepartments] = useState(0);
  const [employeeRolesData, setEmployeeRolesData] = useState([]);
  const [taskStatusData, setTaskStatusData] = useState([]);

  const fetchTasks = async () => {
    setLoading(true);
    try {
      const taskUrl = `https://aligndesk.dropyourbusiness.com/api/tasks`;
      // Fetch task data
      const response = await axios.get(taskUrl);
      const taskData = response.data.task;
      // Count tasks based on status
      const statusCounts = {
        completed: 0,
        pending: 0,
        ongoing: 0,
        inreview: 0,
      };
      taskData.forEach((task) => {
        const status = task.project_task_status?.toLowerCase();
        if (statusCounts.hasOwnProperty(status)) {
          statusCounts[status]++;
        }
      });
      // Prepare Pie Chart Data
      const pieChartData = [
        { name: "Pending", value: statusCounts.pending },
        { name: "Ongoing", value: statusCounts.ongoing },
        { name: "InReview", value: statusCounts.inreview },
        { name: "Completed", value: statusCounts.completed },
      ];
      setTaskStatusData(pieChartData);
      setTasks(taskData.length); // Store only task count, not the entire array
    } catch (error) {
      console.error("Error fetching task data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchTasks();
  }, []);

  const TASK_STATUS_COLORS = {
    pending: "#fd9696",
    ongoing: "#FFA726",
    inreview: "#42A5F5",
    completed: "#66BB6A",
    deadline: "#FF0000",
  };

  // const EMPLOYEE_ROLE_COLORS = {
  //   employees: "#1D3557", // Dark Navy (Professional & Reliable)
  //   teamleaders: "#E63946", // Strong Red (Power & Influence)
  //   managers: "#A8DADC", // Soft Cyan (Calm & Strategic)
  // };
  const EMPLOYEE_ROLE_COLORS = {
    employees: "#1E3A8A", // Royal Blue (Professional & Dependable)
    teamleaders: "#FF6B6B", // Coral Red (Energy & Authority)
    managers: "#48CAE4", // Sky Blue (Innovation & Vision)
  };
  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/emp"
      );

      const employeeData = response.data.employees.map((emp) => ({
        Role: emp.employee_role,
      }));

      // Count each role
      const managers = employeeData.filter((emp) => emp.Role === "M").length;
      const teamLeaders = employeeData.filter((emp) => emp.Role === "T").length;
      const employees = employeeData.filter((emp) => emp.Role === "E").length;
      // Set Pie Chart Data
      const pieChartData = [
        { name: "Managers", value: managers },
        { name: "Team Leaders", value: teamLeaders },
        { name: "Employees", value: employees },
      ];
      setEmployeeRolesData(pieChartData);
      setEmployees(employeeData.length);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchEmployees();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const companysData = await axios.get(
          "https://aligndesk.dropyourbusiness.com/api/company"
        );
        setCompanys(companysData.data.company.length || 0);
        const projectsData = await axios.get(
          "https://aligndesk.dropyourbusiness.com/api/projects"
        );
        setProjects(projectsData.data.project.length || 0);
        const employeesData = await axios.get(
          "https://aligndesk.dropyourbusiness.com/api/emp"
        );
        setEmployees(employeesData.data.employees.length || 0);
        const tasksData = await axios.get(
          "https://aligndesk.dropyourbusiness.com/api/tasks"
        );
        setTasks(tasksData.data.task.length || 0);
        const teamsData = await axios.get(
          "https://aligndesk.dropyourbusiness.com/api/teams"
        );
        setTeams(teamsData.data.team.length || 0);
        const departmentsData = await axios.get(
          "https://aligndesk.dropyourbusiness.com/api/dept"
        );
        setDepartments(departmentsData.data.department.length || 0);
        const pieData = [
          { name: "Companies", value: companysData.data.company.length || 0 },
          {
            name: "Departments",
            value: departmentsData.data.department.length || 0,
          },
          { name: "Projects", value: projectsData.data.project.length || 0 },
          {
            name: "Employees",
            value: employeesData.data.employees.length || 0,
          },
          { name: "Teams", value: teamsData.data.team.length || 0 },
          { name: "Tasks", value: tasksData.data.task.length || 0 },
        ];
        setDashboardData(pieData);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };
    fetchData();
  }, []);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userData = JSON.parse(localStorage.getItem("user"));
  const userId = userData?.id;
  // if (loading) return <p>Loading dashboard data...</p>;
  //Only show the error message if there's an actual API failure, not when tasks are 0
  if (error) return <p className="error">{error}</p>;
  const noTasks = Object.values(Data).every((count) => count === 0);
  return (
    <div className="dashboard-main">
      <div className="dashboard">
        <div className="card total-companies">
          <div className="icon-bg">
            <FaBuilding />
          </div>
          <div className="card-text">
            <h3>Total Companies</h3>
            <p>{comapnys}</p>
          </div>
        </div>
        <div className="card total-departments">
          <div className="icon-bg">
            <FaSitemap />
          </div>
          <div className="card-text">
            <h3>Total Departments</h3>
            <p>{departments}</p>
          </div>
        </div>
        <div className="card total-projects">
          <div className="icon-bg">
            <FaProjectDiagram />
          </div>
          <div className="card-text">
            <h3>Total Projects</h3>
            <p>{projects}</p>
          </div>
        </div>
        <div className="card total-employees">
          <div className="icon-bg">
            <FaUsers />
          </div>
          <div className="card-text">
            <h3>Total Employees</h3>
            <p>{employees}</p>
          </div>
        </div>
        <div className="card total-teams">
          <div className="icon-bg">
            <FaUsersCog />
          </div>
          <div className="card-text">
            <h3>Total Teams</h3>
            <p>{teams}</p>
          </div>
        </div>
        <div className="card total-tasks">
          <div className="icon-bg">
            <FaTasks />
          </div>
          <div className="card-text">
            <h3>Total Tasks</h3>
            <p>{tasks}</p>
          </div>
        </div>
      </div>
      <div className="chart-main-container">
        <div className="chart-container">
          <h3>Employee Role Distribution</h3>
          <ResponsiveContainer height={300}>
            <PieChart>
              <Pie
                data={employeeRolesData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ name, percent }) =>
                  `${name} ${(percent * 100).toFixed(0)}%`
                }
              >
                {employeeRolesData.map((entry) => (
                  <Cell
                    key={entry.name}
                    fill={
                      EMPLOYEE_ROLE_COLORS[
                        entry.name.toLowerCase().replace(" ", "")
                      ] || "#8884d8"
                    }
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="chart-container">
          <h3>Task Status Distribution</h3>
          <ResponsiveContainer height={300}>
            <PieChart>
              <Pie
                data={taskStatusData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ name, percent }) =>
                  `${name} ${(percent * 100).toFixed(0)}%`
                }
              >
                {taskStatusData.map((entry) => (
                  <Cell
                    key={entry.name}
                    fill={
                      TASK_STATUS_COLORS[entry.name.toLowerCase()] || "#8884d8"
                    }
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};
export default Admindashboard;
